var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYlF(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9930_8834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1172 14.2734L10.6484 8.82031H10.8359C10.875 8.82031 10.9219 8.79688 10.9531 8.76562L13.9844 5.94531C14.4141 5.54688 14.6953 5.375 15.0938 5.375C15.6875 5.375 16.1172 5.84375 16.1172 6.42188V14.2734ZM18.8438 20.1094L5.17188 6.46094C4.9375 6.21875 4.9375 5.8125 5.17188 5.57812C5.41406 5.33594 5.8125 5.33594 6.05469 5.57812L19.7188 19.2344C19.9609 19.4766 19.9609 19.8672 19.7188 20.1094C19.4844 20.3516 19.0859 20.3516 18.8438 20.1094ZM8.28906 15.6719C7.14844 15.6719 6.5625 15.0703 6.5625 13.8594V10.8906C6.5625 10.3203 6.69531 9.88281 6.96094 9.59375L16.0391 18.6719C15.8906 19.1328 15.5469 19.3516 15.1016 19.3516C14.7031 19.3516 14.3828 19.1953 13.9844 18.8203L10.6719 15.7344C10.625 15.6875 10.5703 15.6719 10.4922 15.6719H8.28906Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9930_8834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYlF);
export default __webpack_public_path__ + "static/media/yl_f.bceeaf554c7c8a307227f1f8cefc2ac4.svg";
export { ForwardRef as ReactComponent };